module.exports = __webpack_public_path__ + "img/banner-24.d7e76c89.jpg";